var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbnormalCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.6188V11.5349M14 16.9045V16.9316M17.78 19.5H10.22C9.1874 19.5 8.31595 18.7962 8.04177 17.8333C7.92473 17.4223 8.06854 16.9941 8.28851 16.6296L12.0685 9.6007C12.9541 8.1331 15.0459 8.1331 15.9315 9.60071L19.7115 16.6296C19.9315 16.9941 20.0753 17.4223 19.9582 17.8333C19.6841 18.7962 18.8126 19.5 17.78 19.5Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbnormalCircle);
export default __webpack_public_path__ + "static/media/abnormal-circle.b780b187113f0594e30e9b30cd178d92.svg";
export { ForwardRef as ReactComponent };